import { MapPin, Eye, Calendar, User } from "lucide-react";
import { formatPrice, formatDate } from "@/lib/api";

const factRows = (l) => [
  ["Location", MapPin, l.location],
  ["Posted", Calendar, formatDate(l.created_at)],
  ["Views", Eye, l.views || 0],
  ["Seller", User, l.owner_name || "anon"],
];

export function ListingFacts({ listing }) {
  const rows = factRows(listing);
  return (
    <>
      <div className="p-4 border-b border-black">
        <div className="font-mono-data text-xs uppercase text-gray-600">{listing.category?.replace("-", " ")} · {listing.condition}</div>
        <h1 className="font-display text-3xl md:text-4xl uppercase leading-tight mt-1" data-testid="listing-title">{listing.title}</h1>
        <div className="font-mono-data text-4xl md:text-5xl font-bold mt-3" data-testid="listing-price">{formatPrice(listing.price, listing.currency)}</div>
      </div>
      <table className="w-full font-mono-data text-xs uppercase">
        <tbody>
          {rows.map(([label, Icon, value], i) => (
            <tr key={label} className={i < rows.length - 1 ? "border-b border-black" : ""}>
              <td className="p-3 bg-[#F9F9F9] w-1/3">{label}</td>
              <td className="p-3 flex items-center gap-1"><Icon size={12} /> {value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
